import * as React from 'react';
import Link from 'components/Link';
import Sentry from 'utils/shared/sentry';
import Head from 'components/Head';
import useViewer from 'hooks/useViewer';
import { RequestStatus } from 'constants/requests';
import { TERMS_OF_SERVICE_PAGE } from 'constants/pages';
import FormWrapper from './FormWrapper';

import { Button } from 'styles/elements';
import { FormTitle, TextLink, SuccessWrapper } from './styles';

const TITLE = 'Verify Email';
const DESCRIPTION = 'Verify your InsiderFinance account';
const PAGE_REFRESH_TIME = 20_000;

const Signup = () => {
  const viewer = useViewer();
  const [isDisabled, setIsDisabled] = React.useState(false);
  const [requestStatus, setRequestStatus] = React.useState(RequestStatus.Idle);
  const sendVerificationEmail = () => {
    setIsDisabled(true);
    if (requestStatus !== RequestStatus.InProgress && requestStatus !== RequestStatus.Success) {
      viewer.viewer
        ?.sendEmailVerification()
        .then(() => {
          setRequestStatus(RequestStatus.Success);
        })
        .catch((error) => {
          setRequestStatus(RequestStatus.Error);
          Sentry.withScope((_scope) => {
            Sentry.captureException(error);
          });
        });
    }
  };
  React.useEffect(() => {
    let timeout = setInterval(() => {
      window.location.reload();
    }, PAGE_REFRESH_TIME);
    return () => clearInterval(timeout);
  }, []);
  return (
    <>
      <Head title={TITLE} description={DESCRIPTION} useCurrentUrl />

      <div className="styled-font">
        <FormWrapper>
          <FormTitle>Verify Email</FormTitle>
          <div className="mb-8 text-center text-gray-400">
            You must verify your email address to use InsiderFinance. If it doesn't show up in your
            inbox in a few minutes, check your spam box or other filtered folders. You can request a
            new link below or message us at team@insiderfinance.io if you're having issues.
          </div>
          <Button disabled={isDisabled} onClick={sendVerificationEmail}>
            {isDisabled ? 'Sending verification email...' : 'Resend Verification Email'}
          </Button>
          {requestStatus === RequestStatus.Success && (
            <SuccessWrapper className="mb-4 text-sm">
              Check your inbox to verify your email address. Reach out to team@insiderfinance.io if
              you have any questions or concerns.
            </SuccessWrapper>
          )}
          <div>
            <div className="mt-4 flex flex-col items-center justify-center font-semibold">
              <Link href={TERMS_OF_SERVICE_PAGE} target="_blank">
                <TextLink className="text-xs">Terms and Conditions</TextLink>
              </Link>
            </div>
          </div>
        </FormWrapper>
      </div>
    </>
  );
};

export default Signup;
